import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';

export interface PublicBrand {
  name: string;
  logoPath: string | null;
}

interface BrandValue {
  brand: PublicBrand | null;
  setBrand: (brand: PublicBrand | null) => void;
}

const BrandContext = createContext<BrandValue | null>(null);

export function BrandProvider({ children }: { children: ReactNode }): JSX.Element {
  const [brand, setBrand] = useState<PublicBrand | null>(null);
  const value = useMemo(() => ({ brand, setBrand }), [brand]);
  return <BrandContext.Provider value={value}>{children}</BrandContext.Provider>;
}

export function useBrand(): BrandValue {
  const ctx = useContext(BrandContext);
  if (!ctx) throw new Error('useBrand precisa estar dentro de BrandProvider.');
  return ctx;
}

/** Enquanto a página estiver montada, a marca do estabelecimento substitui a AgendaPro no topo. */
export function useBrandOverride(brand: PublicBrand | null): void {
  const { setBrand } = useBrand();
  const name = brand?.name ?? null;
  const logoPath = brand?.logoPath ?? null;
  useEffect(() => {
    setBrand(name ? { name, logoPath } : null);
    return () => setBrand(null);
  }, [name, logoPath, setBrand]);
}
